import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./common/contexts/AuthContext";
import { AbilityProvider } from "./common/contexts/AbilityContext";
import { ThemeProvider } from "./common/contexts/ThemeContext";
import { SocketProvider } from "./common/contexts/SocketContext";
import { NotificationProvider } from "./common/contexts/NotificationContext";

// import Register from "./components/RegistrationPage";
// import Login from "./components/LoginPage";
// import ForgotPassword from "./components/ForgotPasswordPage";

// import VerifyEmail from "./common/components/Auth/VerifyEmail";
// import ResetPassword from "./common/components/Auth/ResetPassword";
import UsersList from "./common/components/User/UsersList";
// import Home from "./common/components/Home";
// import MainLayout from "./common/components/MainLayout";
import ProtectedRoute from "./common/components/ProtectedRoute";
import PlatformRoute from "./common/components/PlatformRoute";
import Layout from "./common/components/Layout";
import PlatformLayout from "./components/Platform/PlatformLayout";
import PlatformDashboard from "./components/Platform/PlatformDashboard";
import PlatformRegisterSchool from "./components/Platform/PlatformRegisterSchool";
import PlanManagement from "./components/Platform/PlanManagement";
import PlatformSettings from "./components/Platform/PlatformSettings";
import Settings from "./common/components/Settings";
import RolesList from "./common/components/User/RolesList";
import UserProfile from "./common/components/User/UserProfile";

import StudentList from "./components/Students/StudentList";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./common/components/Auth/Login";
import ForgotPassword from "./common/components/Auth/ForgotPassword";
// import RegistrationPage from "./components/RegistrationPage";
// import LoginPage from "./components/LoginPage";
// import ForgotPasswordPage from "./components/ForgotPasswordPage";

import GradesList from "./components/page/GradeList.jsx";
import SubjectListing from "./components/Subjects/SubjectListing.jsx";
import GradeCurriculumManager from "./components/Curriculum/GradeCurriculumManager.jsx";
import SessionListing from "./components/Sessions/SessionListing.jsx"
import HolidayCalendar from "./components/Sessions/HolidayCalendar.jsx";
import DataImportPage from "./components/Import/DataImportPage.jsx";
import WebsiteManager from "./components/Website/WebsiteManager.jsx";
import MediaLibrary from "./components/Media/MediaLibrary.jsx";

// import CurriculumSubjectListing from "./components/Curriculum/CurriculumSubjectListing.jsx";
// import curriculumSubject from "../../server/models/curriculumSubject.js";
import AttendanceForm from "./components/Attendance/AttendanceForm";
import EnrollmentList from "./components/Enrollment/EnrollmentList.jsx";
import PromotionPage from "./components/Enrollment/PromotionPage.jsx";
import AttendanceList from "./components/Attendance/AttendancePage.jsx";
// import AttendanceReports from "./components/Attendance/AttendanceReport.jsx";
import ClassRoomList from "./components/ClassRoom/ClassRoomList.jsx";
import ScheduleList from "./components/Schedule/ScheduleList.jsx";
import TeacherDetails from "./common/components/User/TeacherDetails.jsx";
import LeaveList from "./components/Leave/LeaveList.jsx";
import FeeVoucherPage from "./components/FeeVoucher/FeeVoucherPage.jsx";
import Dashboard from "./components/Dashboard/Dashboard";
import WaitlistPage from "./components/Waitlist/WaitlistPage";
import SetupWizard from "./components/Setup/SetupWizard.jsx";
import UpgradePage from "./components/Billing/UpgradePage.jsx";

import ChartOfAccountsPage from "./components/Accounting/ChartOfAccountsPage";
import CashBookPage from "./components/Accounting/CashBookPage";
import FiscalYearPage from "./components/Accounting/FiscalYearPage";
import JournalEntryListPage from "./components/Accounting/JournalEntryListPage";
import JournalEntryFormPage from "./components/Accounting/JournalEntryFormPage";
import TrialBalancePage from "./components/Accounting/TrialBalancePage";
import GeneralLedgerPage from "./components/Accounting/GeneralLedgerPage";

import NotificationsPage from "./common/components/Notifications/NotificationsPage";
import NotificationSettingsPage from "./common/components/Notifications/NotificationSettingsPage";

import MessagesPage from "./components/Messages/MessagesPage";

import ParentDashboard from "./components/Parent/ParentDashboard";

import AssignmentListPage from "./components/Assignments/AssignmentListPage";
import AssignmentFormPage from "./components/Assignments/AssignmentFormPage";
import AssignmentDetailPage from "./components/Assignments/AssignmentDetailPage";

import ExamListPage from "./components/Exams/ExamListPage";
import ExamFormPage from "./components/Exams/ExamFormPage";
import ExamResultsEntryPage from "./components/Exams/ExamResultsEntryPage";
import ReportCardView from "./components/Exams/ReportCardView";
import ParentsPage from "./components/Parents/ParentsPage";
import AcceptInvitePage from "./components/Auth/AcceptInvitePage";
import AttendanceReportPage from "./components/Attendance/AttendanceReportPage";
import TeacherDashboard from "./components/Dashboard/TeacherDashboard";
import AnnouncementsPage from "./components/Announcements/AnnouncementsPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SocketProvider>
          <NotificationProvider>
        <Router>
          <div className="App">
            <ToastContainer />
            <Routes>
              <Route path="/" element={<Login/>} />
              <Route path="/login" element={<Login/>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/setup" element={<SetupWizard />} />
              {/* Outside Layout on purpose: a blocked school's tenant APIs 402, so the
                  upgrade page must not depend on them. */}
              <Route path="/billing" element={<UpgradePage />} />
              <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />
              
              {/* Future expansion */}
              {/* <Route path="/verify-email/:token" element={<VerifyEmail />} /> */}
              {/* <Route path="/reset-password/:token" element={<ResetPassword />} /> */}
              {/* <Route element={<MainLayout />}> ... </Route> */}
              <Route path="/platform" element={<PlatformRoute element={PlatformLayout} />}>
                <Route path="/platform/dashboard" element={<PlatformDashboard />} />
                <Route path="/platform/schools" element={<PlatformDashboard />} />
                <Route path="/platform/register-school" element={<PlatformRegisterSchool />} />
                <Route path="/platform/plans" element={<PlanManagement />} />
                <Route path="/platform/settings" element={<PlatformSettings />} />
                <Route path="/platform/profile" element={<UserProfile />} />
              </Route>

              <Route path="/index" element={<ProtectedRoute element={Layout} />}>
                <Route path="/index/dashboard" element={<Dashboard />} />
                <Route path="/index/profile" element={<UserProfile />} />
                <Route path="/index/users" element={<UsersList />} />
                <Route path="/index/settings" element={<Settings />} />
                <Route path="/index/teachers" element={<UsersList initialTab="Teachers" />} />
                <Route path="/index/roles" element={<RolesList />} />
                <Route path="/index/student" element={<StudentList />} />
                <Route path="/index/parents" element={<ParentsPage />} />

                <Route path="/index/curriculums" element={<GradeCurriculumManager />} />
                <Route path="/index/curriculum-subjects" element={<GradeCurriculumManager />} />
                <Route path="/index/grades" element={<GradesList />} />
                <Route path="/index/subjects" element={<SubjectListing />} />
                <Route path="/index/curriculum-subjects" element={<GradeCurriculumManager />} />
                <Route path="/index/sessions" element={<SessionListing />} />
                <Route path="/index/holidays" element={<HolidayCalendar />} />
                <Route path="/index/import" element={<DataImportPage />} />
                <Route path="/index/website" element={<WebsiteManager />} />
                <Route path="/index/media" element={<MediaLibrary />} />
                <Route path="/index/enrollments" element={<EnrollmentList />} />
                <Route path="/index/promotions" element={<PromotionPage />} />
                <Route path="/index/attendance" element={<AttendanceList />} />
                <Route path="/index/attendance-report" element={<AttendanceReportPage />} />
                <Route path="/index/classroom" element={<ClassRoomList />} />
                <Route path="/index/fee-vouchers" element={<FeeVoucherPage />} />
                <Route path="/index/leaves" element={<LeaveList />} />
                <Route path="/index/waitlist" element={<WaitlistPage />} />

                {/* Accounting */}
                <Route path="/index/accounting/cash-book" element={<CashBookPage />} />
                <Route path="/index/accounting/chart-of-accounts" element={<ChartOfAccountsPage />} />
                <Route path="/index/accounting/fiscal-years" element={<FiscalYearPage />} />
                <Route path="/index/accounting/journal-entries" element={<JournalEntryListPage />} />
                <Route path="/index/accounting/journal-entries/new" element={<JournalEntryFormPage />} />
                <Route path="/index/accounting/journal-entries/:id" element={<JournalEntryFormPage />} />
                <Route path="/index/accounting/trial-balance" element={<TrialBalancePage />} />
                <Route path="/index/accounting/general-ledger" element={<GeneralLedgerPage />} />

                {/* Notifications */}
                <Route path="/index/notifications" element={<NotificationsPage />} />
                <Route path="/index/notification-preferences" element={<NotificationSettingsPage />} />

                {/* Messages */}
                <Route path="/index/messages" element={<MessagesPage />} />

                {/* Parent Portal */}
                <Route path="/index/parent/dashboard" element={<ParentDashboard />} />
                <Route path="/index/teacher/dashboard" element={<TeacherDashboard />} />

                {/* Assignments */}
                <Route path="/index/assignments" element={<AssignmentListPage />} />
                <Route path="/index/assignments/new" element={<AssignmentFormPage />} />
                <Route path="/index/assignments/:id/edit" element={<AssignmentFormPage />} />
                <Route path="/index/assignments/:id" element={<AssignmentDetailPage />} />

                {/* Exams & Results */}
                <Route path="/index/exams" element={<ExamListPage />} />
                <Route path="/index/exams/new" element={<ExamFormPage />} />
                <Route path="/index/exams/:id/edit" element={<ExamFormPage />} />
                <Route path="/index/exams/:id/results" element={<ExamResultsEntryPage />} />
                <Route path="/index/report-card" element={<ReportCardView />} />

                <Route path="/index/attendance-form" element={<AttendanceForm  />} />
                <Route path="/index/schedules" element={<ScheduleList />} />
                <Route path="/index/announcements" element={<AnnouncementsPage />} />


                {/* <Route path="/index/warehouses" element={<Warehouses />} /> */}
                {/* <Route path="/index/price-plans" element={<PricePlans />} /> */}

              </Route>
            </Routes>
          </div>
        </Router>
          </NotificationProvider>
        </SocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
